import { useState } from 'react';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: '김민수',
      position: '투자자',
      company: '서울 강남구',
      content: '한성汗成의 전문적인 투자 자문 덕분에 성공적인 부동산 투자를 할 수 있었습니다. 시장 분석과 투자 전략이 매우 체계적이고 신뢰할 수 있었습니다.',
      rating: 5,
      image: 'https://www.whizcompany.com/images/common/logo-c.png',
    },
    {
      name: '박지영',
      position: '개발사업 파트너',
      company: '경기도 용인시',
      content: '프로젝트 기획부터 완공까지 체계적인 관리와 전문성으로 기대 이상의 결과를 만들어주셨습니다. 앞으로도 계속 함께하고 싶은 파트너입니다.',
      rating: 5,
      image: 'https://www.whizcompany.com/images/common/logo-c.png',
    },
    {
      name: '이준호',
      position: '분양 고객',
      company: '서울 은평구',
      content: '분양 과정에서 친절하고 세심한 상담으로 만족스러운 선택을 할 수 있었습니다. 전문적인 지식과 고객 중심의 서비스가 인상적이었습니다.',
      rating: 5,
      image: 'https://www.whizcompany.com/images/common/logo-c.png',
    },
    {
      name: '최수진',
      position: '자산관리 고객',
      company: '경기도 시흥시',
      content: '효율적인 자산 운영과 관리로 안정적인 수익을 얻고 있습니다. 정기적인 보고와 투명한 관리 시스템이 매우 만족스럽습니다.',
      rating: 5,
      image: 'https://www.whizcompany.com/images/common/logo-c.png',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="fade-up">
          <p className="text-primary text-sm font-semibold tracking-wider uppercase mb-3">
            Testimonials
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4 font-display">
            고객의 목소리
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            한성汗성과 함께한 고객들의 생생한 경험을 들어보세요
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-aos="fade-up" data-aos-delay="100">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-start gap-6 mb-8">
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                <i className="ri-user-line text-3xl text-primary"></i>
              </div>
              <div className="flex-grow">
                <h3 className="text-xl font-bold text-secondary mb-1">
                  {testimonials[activeIndex].name}
                </h3>
                <p className="text-sm text-gray-600 mb-2">
                  {testimonials[activeIndex].position} · {testimonials[activeIndex].company}
                </p>
                <div className="flex gap-1">
                  {Array.from({ length: testimonials[activeIndex].rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-primary text-base"></i>
                  ))}
                </div>
              </div>
              <i className="ri-double-quotes-r text-5xl text-primary/20"></i>
            </div>

            <p className="text-gray-700 text-base leading-relaxed mb-8">
              {testimonials[activeIndex].content}
            </p>

            <div className="flex items-center justify-between">
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      activeIndex === index ? 'w-8 bg-primary' : 'w-2 bg-gray-300'
                    }`}
                  ></button>
                ))}
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() =>
                    setActiveIndex((prev) =>
                      prev === 0 ? testimonials.length - 1 : prev - 1
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-lg"></i>
                </button>
                <button
                  onClick={() =>
                    setActiveIndex((prev) =>
                      prev === testimonials.length - 1 ? 0 : prev + 1
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center" data-aos="fade-up" data-aos-delay="100">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
              <i className="ri-star-line text-2xl text-primary"></i>
            </div>
            <div className="text-3xl font-bold text-secondary mb-2 font-display">4.9/5.0</div>
            <div className="text-sm text-gray-600">평균 고객 평점</div>
          </div>
          <div className="text-center" data-aos="fade-up" data-aos-delay="200">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
              <i className="ri-user-heart-line text-2xl text-primary"></i>
            </div>
            <div className="text-3xl font-bold text-secondary mb-2 font-display">98%</div>
            <div className="text-sm text-gray-600">고객 만족도</div>
          </div>
          <div className="text-center" data-aos="fade-up" data-aos-delay="300">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
              <i className="ri-repeat-line text-2xl text-primary"></i>
            </div>
            <div className="text-3xl font-bold text-secondary mb-2 font-display">95%</div>
            <div className="text-sm text-gray-600">재계약률</div>
          </div>
        </div>
      </div>
    </section>
  );
}
